var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAutomation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 10.8188C9.75 11.4156 9.98705 11.9879 10.409 12.4098C10.831 12.8318 11.4033 13.0688 12 13.0688C12.5967 13.0688 13.169 12.8318 13.591 12.4098C14.0129 11.9879 14.25 11.4156 14.25 10.8188C14.25 10.2221 14.0129 9.64981 13.591 9.22786C13.169 8.8059 12.5967 8.56885 12 8.56885C11.4033 8.56885 10.831 8.8059 10.409 9.22786C9.98705 9.64981 9.75 10.2221 9.75 10.8188Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.0688V22.7528",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2852 19.3901C19.5277 18.334 20.5258 17.0205 21.2103 15.5405C21.8948 14.0604 22.2493 12.4492 22.2493 10.8186C22.2493 9.1879 21.8948 7.57673 21.2103 6.09668C20.5258 4.61663 19.5277 3.30309 18.2852 2.24707",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3711 15.9618C17.1167 15.3282 17.7156 14.5401 18.1264 13.652C18.5372 12.764 18.7499 11.7972 18.7499 10.8188C18.7499 9.84033 18.5372 8.87359 18.1264 7.98553C17.7156 7.09748 17.1167 6.30936 16.3711 5.67578",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71413 19.3901C4.47159 18.334 3.47351 17.0205 2.78902 15.5405C2.10453 14.0604 1.75 12.4492 1.75 10.8186C1.75 9.1879 2.10453 7.57673 2.78902 6.09668C3.47351 4.61663 4.47159 3.30309 5.71413 2.24707",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.62881 15.9618C6.8832 15.3282 6.28426 14.5401 5.8735 13.652C5.46275 12.764 5.25 11.7972 5.25 10.8188C5.25 9.84033 5.46275 8.87359 5.8735 7.98553C6.28426 7.09748 6.8832 6.30936 7.62881 5.67578",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutomation);
export default __webpack_public_path__ + "static/media/automation.dba86f451886eaf0799157fb4f80f6fa.svg";
export { ForwardRef as ReactComponent };